import { render } from "./profilePage.vue?vue&type=template&id=861bd380&scoped=true"
import script from "./profilePage.vue?vue&type=script&lang=js"
export * from "./profilePage.vue?vue&type=script&lang=js"

import "./profilePage.vue?vue&type=style&index=0&id=861bd380&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-861bd380"]])

export default __exports__